<template>
  <h1>Applications</h1>
  
  <hr class="my-2" />

  <EditApplicationModal :index="0" />

  <div v-if="applicationsStore.applications.length === 0" class="alert alert-info mt-3">
    Es wurden noch keine Applications erstellt.
  </div>

  <div v-else class="mt-3">
    <ApplicationRow
      v-for="(application, index) in applicationsStore.applications.slice().sort((a: Application, b: Application) => a.titel.localeCompare(b.titel))"
      :key="application.id"
      :application="application"
      :index="index"
    />
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { onMounted } from 'vue';
  import { useApplicationsStore } from '@/stores/applicationsStore';

  import { Application } from '@/models/ApplicationsModels';

  import EditApplicationModal from '@/components/Applications/EditApplicationModal.vue';
  import ApplicationRow from '@/components/Applications/ApplicationRow.vue';
  //#endregion

  const applicationsStore = useApplicationsStore();

  onMounted(async () => {
    await applicationsStore.getApplications();
  });
</script>
